import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import bg from '../assests/bg.jpg';

const RegisterForm = () => {
    const [formData, setFormData] = useState({
        email: '',
        phoneNo: '',
        password: '',
    });
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');
    const navigate = useNavigate();

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value,
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const response = await axios.post('http://103.61.224.178:9876/admin/signup', formData);
            setSuccess('Registration successful!');
            setError('');
            setFormData({
                email: '',
                phoneNo: '',
                password: '',
            });
        } catch (err) {
            setError('Registration failed. Please try again.');
            setSuccess('');
        }
    };

    const handleLoginClick = () => {
        navigate('/'); 
    };

    return (
        <div
            className="container-fluid d-flex align-items-center justify-content-center"
            style={{
                backgroundImage: `url(${bg})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                height: '100vh',
            }}
        >
            <div className="row justify-content-center w-100">
                <div className="col-md-6 col-lg-4">
                    <div
                        className="p-4 rounded shadow-sm"
                        style={{
                            backgroundColor: 'rgba(255, 255, 255, 0.8)', 
                        }}
                    >
                        <h2 className="mb-4 text-center">Register</h2>
                        {error && <div className="alert alert-danger">{error}</div>}
                        {success && <div className="alert alert-success">{success}</div>}
                        <form onSubmit={handleSubmit}>
                            <div className="form-group mb-3">
                                <label htmlFor="email">Email:</label>
                                <input
                                    type="email"
                                    id="email"
                                    name="email"
                                    className="form-control"
                                    value={formData.email}
                                    onChange={handleChange}
                                    autoComplete='off'
                                    required
                                />
                            </div>
                            <div className="form-group mb-3">
                                <label htmlFor="phoneNo">Phone Number:</label>
                                <input
                                    type="text"
                                    id="phoneNo"
                                    name="phoneNo"
                                    className="form-control"
                                    value={formData.phoneNo}
                                    onChange={handleChange}
                                    autoComplete='off'
                                    required
                                />
                            </div>
                            <div className="form-group mb-3">
                                <label htmlFor="password">Password:</label>
                                <input
                                    type="password"
                                    id="password"
                                    name="password"
                                    className="form-control"
                                    value={formData.password}
                                    onChange={handleChange}
                                    autoComplete='off'
                                    required
                                />
                            </div>
                            <div className="d-flex flex-column">
                            <div className="d-flex flex-column">
                                <button type="submit" className="btn btn-success mb-2">SignUp</button>
                                <button type="button" className="btn btn-primary" onClick={handleLoginClick}>
                                    Login
                                </button>
                            </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default RegisterForm;
